import React from 'react'
import Figure from './figure'
import Tile from './tile'
import VisibleColorMenu from './visibleColorMenu'
import ColorElement from './colorElement'
import VisibleFigureMenu from './visibleFigureMenu'
import VisibleTileMenu from './visibleTileMenu'
import SampleMenu from './sampleMenu'
import VisibleSampleMenu from './visibleSampleMenu';
import VisibleCurrentSample from './visibleCurrentSample';
import VisibleMosaic from './mosaic'


import './designApp.css'

const DesignApp = ({ tiles, currentColors, selectedTile, colors }) => {
  return (
    <div id='app-wrapper'>
      <VisibleTileMenu/>
      <VisibleSampleMenu/>
      <div id='modification-menu'>
          <VisibleCurrentSample/>
          <VisibleFigureMenu/>
      </div>
      <VisibleColorMenu/>
      <VisibleMosaic/>
    </div>
  )
};

export default DesignApp;


// WEBPACK FOOTER //
// ./src/components/mosaic/designApp.jsx